import * as React from 'react';
import { styled } from 'styled-components';

import { getColor } from '../../utils';
import type { Colors } from '../../utils/types';

type FormProps = {
  testId?: string;
  backgroundColor?: Colors;
  preventDefault?: boolean;
  onSubmit?: any;
  children: React.ReactNode;
};

const StyledForm = styled.form<FormProps>`
  background-color: ${props => (props.backgroundColor ? getColor(props.backgroundColor) : 'inherit')};
`;

export const Form = React.forwardRef(
  (
    { testId, onSubmit, preventDefault = true, backgroundColor, children }: FormProps,
    ref: React.Ref<HTMLFormElement>
  ) => {
    const onFormSubmit = (e: any) => {
      if (preventDefault) {
        e.preventDefault();
      }
      onSubmit(e);
    };

    return (
      <StyledForm
        data-testid={testId}
        backgroundColor={backgroundColor}
        onSubmit={(e: any) => {
          onFormSubmit(e);
        }}
        ref={ref}
      >
        {children}
      </StyledForm>
    );
  }
);
